export enum UserSettingsDefaultOptionsEnum {
  AllSubsystems = 'All subsystems',
  AllApplications = 'All applications',
}
